import { StyleSheet } from 'lib/paypalphrodite'

export default StyleSheet.create({
  cardWrapper: {
    position: 'absolute',
    willChange: 'transform', // theoretically should improve animation performance
    marginTop: 50,
    width: 357,
    height: 500,
    margin: '0 auto',
    borderRadius: 5,
    perspective: 1000, // 3D perspective, otherwise it flips in a more 2D sort of way
    transformStyle: 'preserve-3d',
    '@media (max-width: 450px)': {
      float: 'none',
      margin: 0,
      width: 260,
      height: 375,
    },
  },
  cardFront: {
    padding: '20px',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 2,
    backgroundColor: 'white',
    borderRadius: 5,
    backfaceVisibility: 'hidden',
    cursor: 'pointer',
    backgroundSize: '102%',
    backgroundPosition: 'center',

    '@media (max-width: 450px)': {
      backgroundRepeat: 'no-repeat',
      backgroundSize: '105%',
    },
  },
  cardBack: {
    padding: '60px 20px 0',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'white',
    color: 'black',
    borderRadius: 5,
    backfaceVisibility: 'hidden',
    '@media (max-width: 450px)': {
      padding: '40px 20px',
    },
  },
  newCardBack: {
    background: '#4064AC',
    padding: '0 20px 0',
    '@media (max-width: 450px)': {
      padding: 0,
    },
  },
  footerThemeImage: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 40,
    height: 65,
    backgroundSize: 'cover',
    '@media (max-width: 450px)': {
      height: 48,
      bottom: 20,
    },
  },
  transactionDetails: {
    padding: '4px 40px',
    textAlign: 'center',
    '@media (max-width: 450px)': {
      padding: '0 40px',
      fontSize: 18,
    },
  },
  transactionAmount: {
    fontWeight: 800,
  },
  newTransactionDetails: {
    color: 'white',
  },
  transactionDetailsSmallerSize: {
    fontSize: '1.1em',
  },
  textArea: {
    background: 'none',
    border: 'none',
    width: 300,
    outline: 'none',
    textAlign: 'center',
    color: '#6c7378',
    padding: '10px 15px',
    borderRadius: 5,
    transition: 'background 500ms ease',
    resize: 'none',
    ':hover': {
      background: 'rgba(0, 0, 0, .04)',
    },
    ':focus': {
      background: 'rgba(0, 0, 0, .04)',
      outline: 'auto',
    },
    '@media (max-width: 450px)': {
      width: 205,
      height: 90,
    },
  },
  newTextArea: {
    background: '#F5FBFE',
    textAlign: 'left',
    color: '#687173',
    ':hover': {
      background: 'white',
    },
    ':focus': {
      background: 'white',
      outline: 'auto',
    },
    '@media (max-width: 450px)': {
      width: 205,
    },
  },
  staticMessage: {
    textAlign: 'center',
    color: '#6c7378',
    overflow: 'auto',
    padding: '10px 40px',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    '@media (max-width: 450px)': {
      padding: '0 10px 10px',
    },
  },
  messageLargeHeight: {
    height: 155,
    '@media (max-width: 450px)': {
      height: 100,
    },
  },
  newMessageLargeHeight: {
    height: 370,
    '@media (max-width: 450px)': {
      height: 256,
    },
  },
  messageSmallHeight: {
    height: 130,
    '@media (max-width: 450px)': {
      height: 70,
    },
  },
  contactClassName: {
    margin: '0 auto',
  },
})
